import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import BarChartIcon from '@mui/icons-material/BarChart';

// Placeholder components for admin routes
const AdminDashboard = () => <div>Admin Dashboard - Coming Soon</div>;
const SchoolManagement = () => <div>School Management - Coming Soon</div>;
const UserManagement = () => <div>User Management - Coming Soon</div>;
const SystemSettings = () => <div>System Settings - Coming Soon</div>;
const Analytics = () => <div>Analytics - Coming Soon</div>;

/**
 * AdminLayout component for platform administrators
 * Provides navigation and routes for admin-specific features
 */
const AdminLayout: React.FC = () => {
  const navigationItems = [
    {
      label: 'Dashboard',
      path: '/admin/dashboard',
      icon: <DashboardIcon />,
    },
    {
      label: 'Schools',
      path: '/admin/schools',
      icon: <SchoolIcon />,
    },
    {
      label: 'Users',
      path: '/admin/users',
      icon: <PeopleIcon />,
    },
    {
      label: 'Analytics',
      path: '/admin/analytics',
      icon: <BarChartIcon />,
    },
    {
      label: 'Settings',
      path: '/admin/settings',
      icon: <SettingsIcon />,
    },
  ];

  return (
    <BaseLayout title="Admin Portal" navigationItems={navigationItems}>
      <Routes>
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="schools" element={<SchoolManagement />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<SystemSettings />} />
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </BaseLayout>
  );
};

export default AdminLayout;
